// Single source of truth for API paths. Both the worker routes and the web api
// client import these, so a rename breaks compilation on both sides.

export const ROUTES = {
  // cache / account
  cacheStatus: "/api/cache/status",
  account: "/api/account",

  // groups + refresh bracketing
  groupsRefreshBegin: "/api/groups/refresh/begin",
  groupsBulkUpsert: "/api/groups/bulk-upsert",
  groupsRefreshCommit: "/api/groups/refresh/commit",
  groups: "/api/groups",
  groupsCount: "/api/groups/count",
  group: (peerId: string) => `/api/groups/${encodeURIComponent(peerId)}`,

  // tags
  tags: "/api/tags",
  tag: (id: number) => `/api/tags/${id}`,
  tagAssign: (id: number) => `/api/tags/${id}/assign`,
  tagUnassign: (id: number) => `/api/tags/${id}/unassign`,
  tagAssignByFilter: (id: number) => `/api/tags/${id}/assign-by-filter`,

  // draft + image
  draft: "/api/draft",
  image: "/api/image",
  imageByKey: (key: string) => `/api/image/${encodeURIComponent(key)}`,
  imagePresign: "/api/image/presign",

  // broadcasts + send loop
  broadcasts: "/api/broadcasts",
  broadcastActive: "/api/broadcasts/active",
  broadcast: (id: number) => `/api/broadcasts/${id}`,
  broadcastMaterialize: (id: number) => `/api/broadcasts/${id}/materialize`,
  broadcastRiskAck: (id: number) => `/api/broadcasts/${id}/risk-ack`,
  broadcastStart: (id: number) => `/api/broadcasts/${id}/start`,
  broadcastPause: (id: number) => `/api/broadcasts/${id}/pause`,
  broadcastResume: (id: number) => `/api/broadcasts/${id}/resume`,
  broadcastStop: (id: number) => `/api/broadcasts/${id}/stop`,
  broadcastProgress: (id: number) => `/api/broadcasts/${id}/progress`,
  broadcastTargets: (id: number) => `/api/broadcasts/${id}/targets`,
  broadcastNextBatch: (id: number) => `/api/broadcasts/${id}/next-batch`,
  broadcastReport: (id: number) => `/api/broadcasts/${id}/report`,

  // optional ws proxy
  ws: "/api/ws",
} as const;

/** Max dialog rows the browser posts per bulk-upsert request. */
export const UPSERT_CHUNK = 100;
/** Claim/report batch size for the send loop (fits D1 100-param cap). */
export const SEND_BATCH = 20;
/** Groups list keyset page size. */
export const GROUPS_PAGE = 200;
